import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CalendarModule } from "@bfx/primeng/calendar";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DialogModule } from "@bfx/primeng/dialog";
import { DomHandler } from "@bfx/primeng/dom";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { FieldsetModule } from "@bfx/primeng/fieldset";
import { MenuModule } from "@bfx/primeng/menu";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { TabViewModule } from "@bfx/primeng/tabview";
import { InputSwitchModule } from "@bfx/primeng/inputswitch";
import { MultiSelectModule } from "@bfx/primeng/multiselect";
import { SliderModule } from "@bfx/primeng/slider";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";

import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";

import { BfxFindPatchCloseCellEvent } from "./bfx-find-close-cell-event.directive";
import { BfxFindFilterSelectorComponent } from "./bfx-find-filter-selector.component";
import { BfxFindFilterSelectorService } from "./bfx-find-filter-selector.service";
import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";
import { BfxFindService } from "./bfx-find.service";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    AutoCompleteModule,
    BfxElementsLibraryModule,
    BfxInterfaceControlsModule,
    ButtonModule,
    CalendarModule,
    CommonModule,
    DataTableModule,
    DialogModule,
    DropdownModule,
    FieldsetModule,
    FlexLayoutModule,
    FormsModule,
    InputSwitchModule,
    MenuModule,
    MultiSelectModule,
    PerfectScrollbarModule,
    SliderModule,
    SpinnerModule,
    TabViewModule,
    TranslateModule,
    BfxBlotterFilterModule,
    BfxSharedModule,
    NativeDesktopModule,
    BaseComponentsModule,
  ],
  declarations: [BfxFindPatchCloseCellEvent, BfxFindFilterSelectorComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxFindFilterSelectorService,
    BfxFindService,
    DomHandler,
  ],
  exports: [BfxFindPatchCloseCellEvent, BfxFindFilterSelectorComponent],
  bootstrap: [],
})
export class BfxFindModule {}
